"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Error;
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const Page_1 = __importDefault(require("../Page"));
const Text_1 = __importDefault(require("../Text"));
const __1 = require("../..");
const Image_1 = __importDefault(require("../Image"));
const useStyles = (0, core_1.makeStyles)((theme) => ({
    page: {
        backgroundColor: __1.StyleVariables.colors.white,
        padding: 0,
    },
    header: {
        fontWeight: 600,
        color: __1.StyleVariables.colors.grey5,
        marginTop: '2rem',
        [theme.breakpoints.down('xs')]: {
            marginTop: '3rem',
        },
    },
    button: {
        margin: '0.5rem',
        borderRadius: '50px',
        backgroundColor: __1.StyleVariables.colors.action.primary.default,
    },
    buttonText: {
        fontWeight: 600,
        color: __1.StyleVariables.colors.white,
        lineHeight: __1.StyleVariables.fonts.lineHeight.h5,
    },
    buttonsContainer: {
        marginTop: '0.5rem',
    },
    image: {
        width: '60vw',
        maxWidth: '500px',
        margin: '3rem 0',
    },
    gridContainer: {
        padding: '1rem',
    },
}));
function Error({ header, body, imgSrc, imgAlt, children, }) {
    const classes = useStyles();
    return (react_1.default.createElement(Page_1.default, { className: classes.page },
        react_1.default.createElement(core_1.Grid, { container: true, direction: "column", alignContent: "center", className: classes.gridContainer },
            imgSrc && (react_1.default.createElement(core_1.Grid, { item: true, container: true, direction: "column", alignItems: "center" },
                react_1.default.createElement(Image_1.default, { src: imgSrc, alt: imgAlt, className: classes.image, "data-testid": 'img' }))),
            header && (react_1.default.createElement(core_1.Grid, { item: true },
                react_1.default.createElement(Text_1.default, { center: true, as: "h2", className: classes.header, "data-testid": "header" }, header))),
            body && react_1.default.createElement(core_1.Grid, { item: true }, body),
            children && (react_1.default.createElement(core_1.Grid, { item: true, container: true, direction: "row", alignItems: "center", justifyContent: "center", className: classes.buttonsContainer }, children)))));
}
